import { render, staticRenderFns } from "./DocumentSharingModal.vue?vue&type=template&id=6d9d5876&scoped=true&"
import script from "./DocumentSharingModal.vue?vue&type=script&lang=js&"
export * from "./DocumentSharingModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSharingModal.vue?vue&type=style&index=0&id=6d9d5876&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9d5876",
  null
  
)

export default component.exports